var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgQuestionType = function SvgQuestionType(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#FAFAFA",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25,
    d: "M6.078 2.539a1.389 1.389 0 1 0-2.573 0c.051.124.077.186.07.22a.099.099 0 0 1-.047.07c-.028.018-.087.018-.203.018h-.033c-.934 0-1.4 0-1.757.182-.314.16-.569.415-.728.728-.182.357-.182.823-.182 1.757v.389a1.389 1.389 0 1 1 0 2.222v.389c0 .933 0 1.4.182 1.757.16.313.414.568.728.728.357.182.823.182 1.757.182h3c.933 0 1.4 0 1.756-.182.314-.16.569-.415.729-.729.181-.356.181-.823.181-1.756v-.31c0-.117 0-.176.019-.204a.099.099 0 0 1 .07-.047c.033-.007.096.019.22.07a1.389 1.389 0 1 0-.217-2.46c-.039.023-.092-.003-.092-.05 0-.933 0-1.4-.181-1.756a1.667 1.667 0 0 0-.729-.728c-.356-.182-.823-.182-1.756-.182h-.033c-.117 0-.175 0-.203-.018a.099.099 0 0 1-.048-.07c-.006-.034.02-.096.07-.22Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgQuestionType);
export default ForwardRef;